  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.quick-add-button').forEach(button => {
      button.addEventListener('click', function () {
        const variantId = this.dataset.variantId;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(response => {
          if (!response.ok) throw new Error('Add to cart failed.');
          return response.json();
        })
        .then(data => {
          // ✅ Fetch updated cart
          return fetch('/cart.js');
        })
        .then(res => res.json())
        .then(cart => {
          const countEl = document.querySelector('.cart-count');
          const bubbleEl = document.querySelector('.cart-count-bubble');

          if (countEl && bubbleEl) {
            if (cart.item_count > 0) {
              countEl.textContent = cart.item_count;
              bubbleEl.style.display = 'block';
            } else {
              bubbleEl.style.display = 'none';
            }
          }
        })
        .catch(error => {
          console.error('Quick Add error:', error);
          alert('Could not add item to cart.');
        });
      });
    });
  });




    jQuery(document).ready(function () {
   
    jQuery(".more-content").hide();
    jQuery(".show_hide").on("click", function () {
        var txt = jQuery(".more-content").is(':visible') ? 'Read More' : 'Read Less';
      $('.more-content').slideToggle(200);
	
      
        jQuery(".show_hide").text(txt);
	jQuery('.more-content').focus();
        
    });
});

    
 document.addEventListener("DOMContentLoaded", function () {
  let announcementText = document.querySelector('#announcement-message');

  if (announcementText) {
    let messages = [
      {
        text: announcementText.dataset.message1,
        iconBefore: "",
        iconAfter: announcementText.dataset.icon1 || "",
        svg: announcementText.dataset.svg1 || ""
      },
      {
        text: announcementText.dataset.message2,
        iconBefore: announcementText.dataset.icon2 || "",
        iconAfter: "",
        svg: announcementText.dataset.svg2 || ""
      }
    ].filter(item => item.text);

    const iconBeforeSpan = announcementText.querySelector('.icon-before');
    const iconAfterSpan = announcementText.querySelector('.icon-after');
    const textSpan = announcementText.querySelector('.text');
    const svgContainer = announcementText.querySelector('.icon-svg');

    function updateMessage(index) {
      const message = messages[index];

      // Set icons and text
      iconBeforeSpan.textContent = message.iconBefore;
      iconAfterSpan.textContent = message.iconAfter;
      textSpan.textContent = message.text;

      // Reset SVG container
      svgContainer.innerHTML = '';
      svgContainer.style.display = 'none';

      // If SVG provided, insert it
      if (message.svg && message.svg !== '' && !message.svg.includes('no-image')) {
        const img = document.createElement('img');
        img.src = message.svg;
        img.alt = 'SVG Icon';
        img.style.width = '0.8em';
        img.style.height = '0.8em';
        img.style.verticalAlign = 'middle';
        svgContainer.appendChild(img);
        svgContainer.style.display = 'inline-block';
      }
    }

    if (messages.length > 1) {
      let index = 0;
      updateMessage(index);
      setInterval(function () {
        index = (index + 1) % messages.length;
        updateMessage(index);
      }, 5000);
    } else {
      updateMessage(0);
    }
  }
});